import Chat from '@material-ui/icons/Chat';

export default {
    icon: Chat,
};
